<div class="top-page-component">
  <a href="#" (click)="scrollToTop()"  class="fixed-bottom-right">
    {{breadcrumb.topPage|translate}}
    <mat-icon (click)="scrollToTop()" [ngClass]="{'display-icon':windowScrolled}">
      arrow_circle_up
    </mat-icon>
  </a> 
</div>
